import React, { useEffect, useState } from "react";
import dots from "../assets/images/dots.svg";
import { Link,useParams, useNavigate, useLocation } from "react-router-dom";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";
import ReactPaginate from "react-paginate";
import { Dropdown, Space, Modal } from "antd";
import { DownOutlined } from "@ant-design/icons";
import moment from "moment";
import arrowleft from "../assets/images/arrow-left.png";

const SearchApp = (props) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const { applicantName } = location.state;

  let applicantDetails = props.data;
  let loading = props.loader;
  let lastPageNumber = props.pagen;
  let lastPage = props.page1;

  const handleChange = (event) => {
    let searchValue = event.target.value;
    setPage(0);
    setSearch(searchValue);
  };
  const handlePage = (page) => {
    setPage(page);
  };
  let searchString = search.trim().toLowerCase();

  if (searchString.length > 0) {
    applicantDetails = applicantDetails.filter((e) =>
      // e.firstname.toLowerCase().match(searchString) || e.email.toLowerCase().includes(searchString)
    `${e.firstname.toLowerCase()} ${e.lastname.toLowerCase()}`.includes(searchString) || e.email.toLowerCase().includes(searchString)

    );
    
  }
  return (
    <div class="wrapper">
      <Nav />
      <div id="content">
        <header>
          <div class="dashboard_header">
            <div class="left-side d-flex ">
            <button
              onClick={() => navigate("/applicants")}
              type="button"
              className="btn btn-link  "
            >
              <img src={arrowleft} className="img-fluid" />{" "}
            </button>      
              <h1>{applicantName}'s Profile Status History</h1>
            </div>
            <div class="user_profile   ">
              <DropdownRight />
            </div>
          </div>
        </header>
        <UserInput
          update={(e) => handleChange(e)}
          handlePage={(page) => handlePage(page)}
        />
        <Table
          data={applicantDetails}
          loader={loading}
          page={page}
          handlePage={(page) => handlePage(page)}
          lastPage={lastPage}
          lastPageNumber={lastPageNumber}
          refreshTable={props.refreshEvoList}
        />
      </div>
    </div>
  );
};
const Table = (props) => {


  let loading = props.loader;
  let lastPage = props.lastPage;
//   let lastPageNumber = props.lastPageNumber;

  const usersPerPage = 7;
  const pagesVisited = props.page * usersPerPage;
  let lastPageNumber = (props.data.length % usersPerPage == 0 ? usersPerPage : props.data.length % usersPerPage)


  const pageCount = Math.ceil(props.data.length / usersPerPage);
  const listEvo = props.data.length;
  const [pageNumber, setPageNumber] = useState(0);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteTeamId, setDeleteTeamId] = useState(0);
  const [deleteTeamName, setDeleteTeamName] = useState("");
  const [error, setError] = useState("");

  const changePage = ({ selected }) => {
    props.handlePage(selected);
    setPageNumber(selected);
  };



  return (
    <>
      <div class="table_vedio_upload dashbord_table    team_table mb_30 over_flow mb-0">
        <table class="table table-borderless table-responsive-md">
          <thead>
            <tr>
              <th scope="col" className="">
                Analyst Name
              </th>
              <th scope="col" className="" >
                Email
              </th>
              <th scope="col" className=" ">
                Phone
              </th>
              <th scope="col" className=" ">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <div
                style={{
                  position: "absolute",
                  marginTop: 250,
                  backgroundColor: "#ffffffc2",
                  marginLeft: 580,

                  backgroundBlendMode: "overlay",
                  zIndex: 100,
                }}
              >
                <SpinnerCircular size="15%" />
              </div>
            ) : (
              <>
                {props.data
                  .slice(pagesVisited, pagesVisited + usersPerPage)
                  .map(function (d, i) {
                    return (
                      <TableRow
                        key={"person-" + i}
                        firstname={d.firstname +' '+ d.lastname}
                        email={d.email}
                        phone={d.phone}
                        is_approved={d.is_approved}
                        is_cancelled={d.is_cancelled}
                      />
                    );
                  })}
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <div className="paginateText">
          <p className="text-table-show">
            {" "}
            Showing{" "}
            {/* {pageNumber === lastPage - 1 ? lastPageNumber : usersPerPage} out of{" "} */}
            {listEvo != 0 ? (props.page === pageCount - 1 ? (pagesVisited + 1 + '-' + (pagesVisited + lastPageNumber)) : (pagesVisited + 1 + '-' + (pagesVisited + usersPerPage))) : 0} out of{" "}
            {listEvo} entries
          </p>
        </div>
        <div className="reactPaginate">
          <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={pageCount}
            onPageChange={changePage}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
          />
        </div>
      </div>
    </>
  );
};

const UserInput = (props) => {
  return (
    <div class="analysts-wraper-head">
      <div class="form-group search_wraper">
        <input
          onChange={(e) => {
            props.update(e);
            props.handlePage(0);
          }}
          name=""
          class="form-control custom_input"
          placeholder="Search here"
        />
      </div>
    </div>
  );
};

const TableRow = (props) => {
 
  return (
    <tr>
      <td>{props.firstname}</td>
      <td style={{wordBreak: "break-all"}}>{props.email}</td>
      <td>{props.phone}</td>
      <td style={{ color: props.is_approved === 1 ? 'green' : props.is_cancelled === 1 ? 'red' : 'orange' }}>{props.is_approved === 1 ? "Approved" : props.is_cancelled === 1 ? "Cancelled" : (props.is_approved === 0 && props.is_cancelled === 0) ? "Pending" : null}</td>
    </tr>
  );
};

export default function ViewAssignApplicantProfile() {
  const params = useParams();  
  const token = localStorage.getItem("xAuthToken");
  const [applicantStatusHistoryDetails, setApplicantStatusHistoryDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const usersPerPage = 7;

  useEffect(() => {
    ApplicantStatusHistory();
  }, []);


  const ApplicantStatusHistory = async () => {
    setLoading(true);

    http
      .get(`api/admin/analyst/applicant-wise/status-details/${params.id}?token=${token}`)
      .then((res) => {
        setLoading(false);
        setApplicantStatusHistoryDetails(res.data.data);
        setLastPageNumber(res.data.data.length % usersPerPage == 0 ? usersPerPage : res.data.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const refreshApplicantStatusHistoryList = () => {
    ApplicantStatusHistory();
  };
  return (
    <>
      <SearchApp
        data={applicantStatusHistoryDetails}
        loader={loading}
        pagen={lastPageNumber}
        page1={lastPage}
        refreshEvoList={refreshApplicantStatusHistoryList}
      />
    </>
  );
}
